module.exports = __webpack_public_path__ + "static/media/asset_5.1079b3e6.jpg";